/**
 * Config Service
 * API client för konfiguration
 */

import api from './client';
import type { ThemeModePalette } from '@/utils/themeDerivation';

export interface Config {
  showTestRunner: boolean;
  /** Server-flagga: dynamiskt tema appliceras endast när true */
  dynamicThemeEnabled?: boolean;
  /** Presigned URL för kundens logotyp (toppnod). Saknas om ingen logotyp är satt. */
  organizationLogoUrl?: string | null;
  /** Organisationsnamn för toppnoden (vid kundlogotyp). */
  organizationName?: string | null;
  theme?: {
    light: ThemeModePalette;
    dark: ThemeModePalette;
    source: 'global' | 'partner';
  };
}

/**
 * Hämta konfiguration
 */
export const getConfig = async (): Promise<Config> => {
  const response = await api.get<{ success: boolean; data: Config }>('/api/config');
  return response.data.data;
};

